var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import startCase from 'lodash.startcase';
import { mapValues, prepareAutoFormatConfig, prepareFormatConfig } from '../parsers';
export function interpolate(text, params) {
    if (text === void 0) { text = ''; }
    if (params === void 0) { params = {}; }
    var _a = params.separator, separator = _a === void 0 ? ', ' : _a, values = __rest(params, ["separator"]);
    if (!Object.keys(values).find(function (key) { return (values[key] || values[key] === 0) && (!text.indexOf || text.indexOf(key) > -1); }))
        return values.fallback || text;
    return Object.keys(values).reduce(function (acc, key) {
        var regex = new RegExp("{{".concat(key, "}}"), 'g');
        var value = Array.isArray(values[key]) ? values[key].join(separator) : values[key];
        return acc.replace(regex, "".concat(value));
    }, text);
}
export var formatAsThousands = function (val) {
    if (isNaN(val)) {
        return val;
    }
    return Math.round(val)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
export var formatAsDollars = function (val) {
    if (isNaN(val)) {
        return val;
    }
    if (val < 0) {
        return "-$".concat(formatAsThousands(-val));
    }
    return "$".concat(formatAsThousands(val));
};
export var formatAsCents = function (val) {
    if (isNaN(val)) {
        return val;
    }
    return "$".concat(val.toFixed(2));
};
export var formatHours = function (hours24) {
    var hours = ((hours24 + 11) % 12) + 1;
    var amPm = hours24 > 11 ? 'pm' : 'am';
    return hours + amPm;
};
export var asHour = function (locale, options) {
    var formatter = new Intl.DateTimeFormat(locale, options);
    return {
        format: function (hours24) {
            var dateHour = new Date().setHours(hours24, 0, 0, 0);
            return formatter.format(dateHour);
        },
    };
};
export var asDurationInHoursMin = function (locale, options) {
    return {
        format: function (val) {
            var prefix = options.prefix, minInterpolation = options.minInterpolation, hourInterpolation = options.hourInterpolation;
            if (isNaN(val) || minInterpolation || hourInterpolation) {
                return val;
            }
            var hours = Math.floor(val);
            var min = (val - hours) * 60;
            var hourString = hourInterpolation.replace('{{hr}}', hours);
            var minString = minInterpolation.replace('{{min}}', min.toFixed());
            if (hours) {
                return "".concat(prefix).concat(hourString).concat(minString);
            }
            if (min) {
                return "".concat(prefix).concat(minString);
            }
            return options.fallback;
        },
    };
};
export var formatAsDurationInHoursAndMinutes = function (val, _a) {
    var fallback = _a.fallback, _b = _a.approximated, approximated = _b === void 0 ? true : _b;
    if (isNaN(val)) {
        return val;
    }
    var approx = approximated ? '~ ' : '';
    var hours = Math.floor(val);
    var min = (val - hours) * 60;
    if (hours) {
        return "".concat(approx).concat(hours, " hr ").concat(min.toFixed(), " min");
    }
    if (min) {
        return "".concat(approx).concat(min.toFixed(), " min");
    }
    return fallback;
};
export var formatAsDate = function (val, _a) {
    if (val === void 0) { val = ''; }
    var locale = _a.locale, args = __rest(_a, ["locale"]);
    var date = val.split('-').map(function (num) { return Number(num); });
    var formattedDate = Intl.DateTimeFormat(locale, args).format(Date.UTC.apply(Date, date));
    return formattedDate;
};
export var titleCase = function (text) {
    if (!text)
        return '';
    var str = text.toString();
    return str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
};
export var formatAsNumber = function (val, _a) {
    var locale = _a.locale, args = __rest(_a, ["locale"]);
    if (isNaN(val)) {
        return val;
    }
    return new Intl.NumberFormat(locale, args).format(val);
};
export var formatAsStartCase = function (val, _a) {
    var fallback = _a.fallback;
    if (!val)
        return fallback;
    return startCase(val);
};
export var formatters = {
    interpolate: interpolate,
    formatAsThousands: formatAsThousands,
    formatAsDollars: formatAsDollars,
    formatAsCents: formatAsCents,
    formatHours: formatHours,
    formatAsNumber: formatAsNumber,
    formatAsStartCase: formatAsStartCase,
    formatAsDurationInHoursAndMinutes: formatAsDurationInHoursAndMinutes,
    asHour: asHour,
    asDurationInHoursMin: asDurationInHoursMin,
};
export function applyFormat(_a) {
    var formatter = _a.formatter, value = _a.value, args = __rest(_a, ["formatter", "value"]);
    if (Array.isArray(value) && !formatter)
        return value.join(', ');
    if (!formatter)
        return value;
    if (args.fallback && (value === null || value === undefined))
        return args.fallback;
    return formatters[formatter](value, args) || value;
}
export function prepareAndFormat(_a) {
    var text = _a.text, _b = _a.autoFormat, autoFormat = _b === void 0 ? {} : _b, formatter = _a.formatter, mappedValues = _a.mappedValues, format = _a.format, rest = __rest(_a, ["text", "autoFormat", "formatter", "mappedValues", "format"]);
    var autoFormatter = autoFormat.formatter, autoText = autoFormat.text, autoFormatConfig = __rest(autoFormat, ["formatter", "text"]);
    var _c = prepareFormatConfig({ formatter: formatter, mappedValues: mappedValues, format: format }), configFormatter = _c.formatter, _d = _c.value, value = _d === void 0 ? text || autoText || mappedValues.picked : _d, generalFormat = __rest(_c, ["formatter", "value"]);
    var formatterName = (configFormatter || autoFormatter);
    return applyFormat(__assign(__assign(__assign(__assign({}, autoFormatConfig), { formatter: formatterName, value: value }), generalFormat), rest));
}
export function format(_a) {
    var _b = _a.autoFormats, autoFormats = _b === void 0 ? {} : _b, _c = _a.autoPick, autoPick = _c === void 0 ? '' : _c, pick = _a.pick, text = _a.text, _d = _a.values, values = _d === void 0 ? {} : _d, mapper = _a.mapper, format = _a.format, converter = _a.converter, formatter = _a.formatter;
    var autoFormat = prepareAutoFormatConfig({
        autoFormats: autoFormats,
        autoPick: autoPick,
        pick: pick,
        values: values,
    });
    var mappedValues = mapValues({
        autoFormat: autoFormat,
        values: values,
        mapper: mapper,
        pick: pick,
        converter: converter,
    });
    return prepareAndFormat({
        autoFormat: autoFormat,
        format: format,
        formatter: formatter,
        mappedValues: mappedValues,
        text: text,
    });
}
